__webpack_require__.p = "/genshin-tierlist-maker/";